import { ConfirmCancelInput, TripOutput } from '@allocab/allocab-passenger-shared-types';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { mutationKeys } from '../services/datastore/mutationKeys';
import { queryKeys } from '../services/datastore/queryKeys';
import { passengerApi } from '../services/network/Api';
import { APIError } from '../services/network/types';

const confirmCancellation = (input: ConfirmCancelInput) =>
  passengerApi.post<ConfirmCancelInput, TripOutput>('/trip/v1/confirm-cancellation', input);

export const useConfirmCancellation = (tripKey: string) => {
  const queryClient = useQueryClient();
  const confirmCancellationMutation = useMutation<TripOutput, APIError, ConfirmCancelInput>({
    mutationKey: mutationKeys.user.confirmCancellation(tripKey),
    mutationFn: confirmCancellation,
    onSuccess: trip => {
      queryClient.setQueryData(queryKeys.user.fetchTrip(trip.key), trip);
    },
  });

  return confirmCancellationMutation;
};
